import { Component, OnInit } from '@angular/core';
import { App, NavController, PopoverController, ModalController, AlertController, NavParams, ViewController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { Subscription, Observable, Subscriber } from 'rxjs';
import * as _ from 'lodash';
import { Events } from 'ionic-angular/util/events';

import { Logs, Users } from 'api/collections';
import { Log, LogType, LogMessage, LogMessageType, Project, User } from 'api/models';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData'
import { AddLogUserPage } from '../add-log-user/add-log-user';
import * as permissions from '../../services/permissions';
import { ISDEV } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

@Component({
  templateUrl: 'log-users.html'
})
export class LogUsersPage implements OnInit {
  log ? : Log;
  logId: string;
  project: Project | void;
  viewer ? : User;
  logMembers ? : Array < User > ;
  public isDev = ISDEV;

  constructor(
      public navParams: NavParams,
      public appCtrl: App,
      private popoverCtrl: PopoverController,
      private viewCtrl: ViewController,
      private navCtrl: NavController,
      private modalCtrl: ModalController,
      private events: Events,
      public httpService: HttpService,
      public projectService: ProjectService,
      private sharedService: SharedService,
      public authenticationService: AuthenticationService
    ) {
      this.logId = <string>navParams.get('logId');
  }

  ngOnInit() {
  if(this.isDev == true) { console.log('log users page') }
    const autorun = MeteorObservable.autorun();
    // const logDetailsSubscription = MeteorObservable.subscribe('logDetails', this.logId);
    const logDetailsSubscription = this.httpService.MeteorSubscribe('logDetails', this.logId);
    this.httpService.privateLoopAction(true).then(()=>{
      Observable.merge(logDetailsSubscription, autorun).subscribe(() => {
        this.viewer = this.authenticationService.MeteorUser();
        this.log = Logs.findOne(this.logId);

        // The log members list consists of:
        // 1) all PMs for a project
        // 2) the creator of the log (only different if they're an updater user)
        // 3) "additionalUsers" that have been manually added to the log visibility
        this.project = this.projectService.getProject(this.log.projectId);
        if (!this.project) {
          return;
        }
        const { creatorId, additionalUserIds, assignedActivityUserIds } = this.log;
        // this is _uniq because a member who was added as an additionalUser may become a pmId in the future
        const userIds = _.uniq([ creatorId, ...(this.project.pmIds || []), ...(assignedActivityUserIds || []), ...(additionalUserIds || []) ]);

        const logMembers = Users.find({_id: {$in: userIds}}).fetch();
        this.logMembers = _.orderBy(logMembers, [(user) => {
          return user._id === creatorId;
        }, (user) => {
          return this.isProjectManager(user);
        }, (user) => {
          return this.isAssignedActivityUser(user);
        }, 'profile.name'], ['desc', 'desc', 'desc', 'asc'])
      })
    });
  }

  isAssignedActivityUser(user: User) {
    if (!this.log) {
      return false;
    }
    return (this.log.assignedActivityUserIds || []).indexOf(user._id) >= 0;
  }

  isProjectManager(user: User) {
    if (!this.project) {
      return false;
    }
    return permissions.isProjectManager(this.project, user);
  }

  isProjectUpdater(user: User) {
    if (!this.project) {
      return false;
    }
    return permissions.isProjectUpdater(this.project, user);
  }

  canAddUsers() {
    if (!(this.project && this.viewer)) {
      return false;
    }
    const isProjectManager = permissions.isProjectManager(this.project, this.viewer);
    const isSuperAdmin = permissions.isSuperAdmin(this.viewer);
    return isProjectManager || isSuperAdmin;
  }

  canRemoveUser(user: User) {
    // PMs cannot be removed from a log
    // The creator cannot be removed from a log
    // only additionalUsers that don't meet the above reqs. can be removed.
    if (!(this.project && this.log && this.viewer)) {
      return false;
    }
    const isViewerProjectManager = permissions.isProjectManager(this.project, this.viewer);
    const isViewerSuperAdmin = permissions.isSuperAdmin(this.viewer);

    const isProjectManager = permissions.isProjectManager(this.project, user);
    const isCreator = user._id === this.log.creatorId;
    const isAdditionalUser = (this.log.additionalUserIds || []).indexOf(user._id) >= 0;
    const isAssignedActivityUser = this.isAssignedActivityUser(user);

    const userIsRemovable = isAdditionalUser && !(isProjectManager || isCreator || isAssignedActivityUser);
    const viewerCanRemove = isViewerProjectManager || isViewerSuperAdmin;

    return userIsRemovable && viewerCanRemove;
  }

  removeLogUser(user) {
    if (!this.log) {
      return;
    }
    // MeteorObservable.call('removeLogUser', this.log._id, user._id).subscribe();
    this.httpService.MeteorCall('removeLogUser', this.log._id, user._id);
  }

  goToAddLogUser() {
    const modal = this.modalCtrl.create(AddLogUserPage, {logId: this.logId}, {enableBackdropDismiss: false});
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/log-users/log-users.ts